import { render } from "./ChooseVideos.vue?vue&type=template&id=7bccbcc4&scoped=true"
import script from "./ChooseVideos.vue?vue&type=script&lang=js"
export * from "./ChooseVideos.vue?vue&type=script&lang=js"

import "./ChooseVideos.vue?vue&type=style&index=0&id=7bccbcc4&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bccbcc4"]])

export default __exports__